import { keyframes } from 'styled-components'

export const FadeOutWithVisibility = keyframes`
  from {
    opacity: 1;
    visibility: visible;
  }
  50% { opacity: 1; }
  to {
    opacity: 0;
    visibility: hidden;
  }
`
